import * as React from 'react'
import Button from '@mui/material/Button'
import DescriptionIcon from '@mui/icons-material/Description'
import { WebFormSideDrawer } from '../WebFormSideDrawer/WebFormSideDrawer'
import { useData, useHandlers } from './hooks'

type Props = {
  hideInfoBox?: boolean
  initialDraft?: object
  noIcon?: boolean
  text?: string
  type: string
  variant?: 'button' | 'link' | 'button-small'
  webFormCallTrackingEventId?: string | null
  draftLeadId: number | null
  createdTime?: Date | string
  submittedBy?: string
}

export function WebFormButton(props: Props) {
  const {
    noIcon,
    text = 'View Submitted Webform',
    variant = 'button',
    draftLeadId,
  } = props
  const { open, setOpen, onClose } = useData()
  const { handleClick } = useHandlers({ setOpen })

  return (
    <>
      {variant === 'button' && (
        <Button
          variant="text"
          startIcon={noIcon ? null : <DescriptionIcon />}
          onClick={handleClick}
          data-test-id={`webform-btn-${draftLeadId}`}
        >
          {text}
        </Button>
      )}

      {variant === 'link' && (
        <a
          href="#"
          onClick={handleClick}
          data-test-id={`webform-btn-${draftLeadId}`}
        >
          {text}
        </a>
      )}

      {variant === 'button-small' && (
        <Button
          color="primary"
          variant="text"
          size="small"
          onClick={handleClick}
          data-test-id={`webform-btn-${draftLeadId}`}
          sx={{
            textTransform: 'none',
            fontWeight: 'bold',
          }}
        >
          {text}
        </Button>
      )}

      <WebFormSideDrawer open={open} onClose={onClose} {...props} />
    </>
  )
}
